import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface DemolitionDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const DemolitionDescription: React.FC<DemolitionDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [demolitionDescription, set_demolitionDescription] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Demolition']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Demolition': [v, b.values?.['Site Work']?.['Demolition']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={demolitionDescription}
                />
            ) : (
                <TextBox
                    value={demolitionDescription}
                    onChange={(value) => set_demolitionDescription(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
